<template>
  <div
    ref="carousel"
    class="carousel"
  >
    <button
      v-if="showControls"
      :disabled="step === 0"
      class="btn-carousel ml-1"
      @click="onClick(1)"
    >
      <elIcon name="chevron-left" />
    </button>
    <div class="carousel-container pl-2">
      <div
        ref="inner"
        class="inner"
        @mousedown="onMousedown"
      >
        <slot />
      </div>
    </div>
    <button
      v-if="showControls"
      :disabled="disablePrev"
      class="btn-carousel mr-1"
      @click="onClick(-1)"
    >
      <elIcon name="chevron-right" />
    </button>
  </div>
</template>

<script>
import elIcon from './elIcon.vue'
export default {
  components: {
    elIcon
  },
  props: {
    width: {
      type: Number,
      default: 200
    },
    translateBy: {
      type: Number,
      default: 65
    }
  },
  data() {
    return {
      step: 0,
      pos: 0,
      disablePrev: false,
      showControls: true,
      maxWidth: 0
    }
  },
  mounted() {
    this.observer = new MutationObserver(this.setMaxWidth)
    this.observer.observe(this.$refs.inner, {
      childList: true
    })

    window.addEventListener('resize', this.onResize)
    this.setMaxWidth()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
    document.removeEventListener('mousemove', this.onMousemove)
    document.removeEventListener('mouseup', this.onMouseup)
    this.observer.disconnect()
  },
  methods: {
    onClick(val) {
      this.step = this.step + val
      this.pos = this.translateBy * this.step
      this.$refs.inner.style.transform = `translateX(${this.pos}px)`

      this.disablePrev = this.maxWidth + this.pos + this.lastElementHalfWidth() < this.$refs.carousel.offsetWidth
    },
    onResize() {
      this.showControls = this.$refs.carousel.parentElement.offsetWidth < this.maxWidth + this.lastElementHalfWidth()
      if (!this.showControls && this.step !== 0) {
        this.step = 0
        this.onClick(0)
      }
    },
    lastElementHalfWidth() {
      if (!this.$refs.inner.children.length) return 0
      return this.$refs.inner.children[this.$refs.inner.children.length - 1].offsetWidth / 2
    },
    setMaxWidth() {
      this.maxWidth = this.$refs?.inner?.offsetWidth ?? 0
      this.onResize()
    },
    onMousedown(e) {
      if (!this.showControls) return
      this.startClientX = e.clientX
      document.body.style.cursor = 'ew-resize'
      document.addEventListener('mousemove', this.onMousemove)
      document.addEventListener('mouseup', this.onMouseup)
    },
    onMousemove(e) {
      e.preventDefault()
      e.stopPropagation()
      const { clientX } = e
      const diff = this.startClientX - clientX

      if (Math.abs(diff) > this.translateBy) {
        if (diff > 0) {
          this.onClick(-1)
        } else {
          this.onClick(1)
        }
        this.startClientX = clientX
      }
    },
    onMouseup() {
      this.$refs.inner.style.cursor = 'default'
      document.removeEventListener('mousemove', this.onMousemove)
      document.removeEventListener('mouseup', this.onMouseup)
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~@ui/styles/src/scss/utils/lib';

.carousel {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;

  .btn-carousel {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: white;
    background-color: $grey-40;
    border:none;
    border-radius: 50%;

    &:hover:not(:disabled) {
      background-color: $grey-45;
    }

    &:disabled {
      opacity: .5;
    }
  }

  .carousel-container {
    display: flex;
    overflow: hidden;
  }

  .inner {
    display: flex;
    transition: all 0.2s;
  }

}

</style>
